import {
    changeSelectedAccount,
    changeSelectedTeam,
    changeStatusUser,
    getUserSlack,
    getUserSlackLastTime
} from "./users.actions";
import {getUserSlackLastTimeService, getUserSlackService} from "../../../services/user.service";

export const getUserSlackThunk = (email) => {
    return async (dispatch) => {
        dispatch(changeStatusUser('loading'));
        try {
            const data = await getUserSlackService(email);
            console.log("data", data);
            if (!data.error) {
                dispatch(getUserSlack(data)); // Update the list of all accounts first

                // If the user has no accounts, clear the selection and finish.
                if (data.length === 0) {
                    localStorage.removeItem("slackTeamId");
                    dispatch(changeSelectedTeam(null));
                    dispatch(changeSelectedAccount(null));
                    dispatch(changeStatusUser('loaded'));
                    return;
                }

                // If we have accounts, find the correct one to select.
                // It will be the one from localStorage or the first one as a fallback.
                const selectedAccount = getSelectedAccount(data, localStorage.slackTeamId);

                // Now, update the state and localStorage with the definitive account.
                if (selectedAccount) {
                    localStorage.setItem("slackTeamId", selectedAccount.teamId);
                    dispatch(changeSelectedTeam(selectedAccount.teamId));
                    dispatch(changeSelectedAccount(selectedAccount));
                }
                dispatch(changeStatusUser('loaded'));
            }
        } catch (error) {
            console.error(error);
        }
    };
};

export const getUserSlackLastTimeThunk = () => {
    return async (dispatch) => {
        dispatch(changeStatusUser('loading'));
        try {
            const data = await getUserSlackLastTimeService();
            console.log("data Last", data);
            if (!data.error) {
                dispatch(getUserSlackLastTime(data));
                dispatch(changeStatusUser('loaded'));
            }
        } catch (error) {
            console.error(error);
        }
    }
}


export const changeSelectedTeamThunk = (teamId, accounts) => {
    return async (dispatch) => {
        const selectedAccount = getSelectedAccount(accounts, teamId);
        // Only dispatch actions if a valid account was found or defaulted
        if (selectedAccount) {
            localStorage.setItem("slackTeamId", selectedAccount.teamId);
            dispatch(changeSelectedTeam(selectedAccount.teamId));
            dispatch(changeSelectedAccount(selectedAccount));
        }
    }
}


function getSelectedAccount(accounts, teamId) {
    const foundAccount = accounts.find(acc => acc.teamId === teamId);
    // If an account is found, return it. Otherwise, return the first account if it exists.
    return foundAccount || accounts?.[0];
}
